import React, { useEffect, useState } from 'react';
import Logo from "../../Logo";
import { withPrefix } from "gatsby"
const Index = () => {
  const [pageScroll, setPageScroll] = useState(false);
  const [mobileScroll, setMobileSCroll] = useState(false);
  const [toggle, setToggle] = useState(false)
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", function () {
        if (window.scrollY > 612) {
          setPageScroll(true)

        }
        else {
          setPageScroll(false)
        }
        if (window.scrollY > 330) {
          setMobileSCroll(true);
        }
        else {
          setMobileSCroll(false)
        }

      })
    }
  }, [])
  return (
    <>
      <div className={`hidden md:block md:px-2 xl:px-0 fixed right-0 left-0 transition duration-200 ease-in-out z-30 ${pageScroll ? "bg-white shadow-sm" : "header-gradient"}`}>
        <div className="py-5 desktop-nav container mx-auto px-2">
          <div className="flex justify-between items-center">
            <a href="/" className={`flex items-end ${pageScroll ? "text-black" : "text-white"}`}>
              <Logo />
            </a>
            <ul className="flex">
              <li>
                <a
                  href="/events"
                  className={`font-semibold mr-8 border-b border-transparent  ${pageScroll ? "text-black hover:border-black" : "text-white hover:border-white desktop-nav-shadow"}`}
                >
                  CORPORATE EVENTS
                </a>
              </li>
              <li>
                <a
                  href="/gift"
                  className={`font-semibold mr-8 border-b border-transparent  ${pageScroll ? "text-black hover:border-black" : "text-white hover:border-white desktop-nav-shadow"}`}
                >
                  GIFTS
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  className={`font-semibold mr-8 border-b border-transparent  ${pageScroll ? "text-black hover:border-black" : "text-white hover:border-white desktop-nav-shadow"}`}
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className={`font-semibold border-b border-transparent  ${pageScroll ? "text-black hover:border-black" : "text-white hover:border-white desktop-nav-shadow"}`}
                >
                  CONTACT
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className={`mobile-nav z-30 fixed top-0 right-0 left-0 py-4 pr-3 md:hidden pl-3 ${mobileScroll ? "bg-white" : "header-gradient"}`}>
        <div className="flex justify-between items-center">
          <a href="/" className={mobileScroll ? "text-black" : "text-white"}>
            <Logo />
          </a>
          <div className="h-12 w-12 bg-white rounded-full flex items-center justify-center" role="button" onClick={() => setToggle(true)} onKeyDown={() => setToggle(true)} tabIndex={0}>
            <img src={withPrefix("/images/menu-open.svg")} alt="Menu open icon" width="18" height="12"/>
          </div>
        </div>
        {
          toggle &&

          <div className="mobile-navigation bg-white">
            <img src={withPrefix("/images/delicious-badge-half.png")} className="absolute bottom-0 sm:hidden" alt="Delicious experience logo" />
            <div className="flex justify-between items-center pr-3 py-4">
              <a href="/" className="flex items-end pl-3 text-black">
                <Logo />
              </a>
              <div className="h-12 w-12 bg-white rounded-full flex items-center justify-center shadow" role="button" onClick={() => setToggle(false)} onKeyDown={() => setToggle(false)} tabIndex={0}>
                <img src={withPrefix("/images/menu-close.svg")} alt="Menu close icon" width="12" height="12"/>
              </div>
            </div>
            <ul className="px-4 mt-16 ">
              <li className="mb-4">
                <a href="/" className="font-freight text-3xl">
                  Home
                </a>
              </li>
              <li className="mb-4">
                <a href="/events" className="font-freight text-3xl">
                  Corporate Events
                </a>
              </li>

              <li className="mb-4">  <a href="/gift" className="font-freight text-3xl">
                Gifts
              </a></li>
              <li className="mb-4"><a href="/faq" className="font-freight text-3xl">
                FAQ
              </a></li>
              <li className="mb-4"> <a href="/contact" className="font-freight text-3xl ">
                Contact Us
              </a></li>
            </ul>
          </div>
        }
      </div>
    </>
  );
};
export default Index;
